import React from "react";

import { Link } from "./styles";

export interface ITextLink {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  target?: "_blank" | "_self";
  disabled?: boolean;
  underline?: boolean;
}

export const TextLink: React.FC<ITextLink> = ({
  children,
  href,
  onClick,
  target = "_self",
  disabled = false,
  underline = true,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  if (href && !onClick) {
    return (
      <Link
        href={href}
        target={target}
        disabled={disabled}
        underline={underline}
      >
        {children}
      </Link>
    );
  }

  return (
    <Link
      as="button"
      type="button"
      onClick={handleClick}
      disabled={disabled}
      underline={underline}
    >
      {children}
    </Link>
  );
};

export default TextLink;
